<div class="grid-container">
	<mat-toolbar style="background-color: transparent"> </mat-toolbar>
	<mat-card>
		<firebase-ui (signInSuccessWithAuthResult)="onSuccess()"></firebase-ui>
	</mat-card>
</div>
